import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'nav-icon-toggle-1',
  templateUrl: './nav-icon-toggle.component.html',
  styleUrls: ['./nav-icon-toggle.component.scss']
  ,changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavIconToggle1Component {
  @Input() type = "icon-cross";
  @Input() tooltip = "Toggle side menu.";
  status = "open";
  private _closed;
  @Input() get closed() {
    return this._closed;
  }
  set closed(value) {
    if (value) {
      this.status = "closed";
      this.classes = this.type + " " + this.status;
    } else {
      this.status = "open";
      this.classes = this.type + " " + this.status;
    }
    this._closed = value;
  }
  @Input() color: string = '#8c8787'; // default color: #333
  @Output() toggled = new EventEmitter<boolean>();
  classes = "";

  toggle() {
    if (this._closed) {
      this.status = "open";
      this.classes = this.type + " " + this.status;
      this._closed = false;
      this.toggled.emit();
      return;
    }
    else {
      this.status = "closed";
      this.classes = this.type + " " + this.status;
      this._closed = true;
      this.toggled.emit();
      return;
    }
  }
}
